import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { IDepartment } from '@app/shared/models/department.model';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {
  private cachedDepartments$: Observable<IDepartment[]>;

  constructor(private http: HttpClient) {
  }

  getDepartments(): Observable<IDepartment[]> {
    if (!this.cachedDepartments$) {
      this.cachedDepartments$ = this.fetchDepartments()
        .pipe(
          shareReplay(1)
        );
    }
    return this.cachedDepartments$;
  }

  private fetchDepartments(): Observable<IDepartment[]> {
    return this.http.get<IDepartment[]>('api/departments');
  }
}
